import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "px-x3"
}
const _hoisted_3 = {
  type: "submit",
  class: "flex-none c-button u-valign-inline-button ml-20"
}
const _hoisted_4 = { class: "flex flex-no-wrap items-start ml-15" }
const _hoisted_5 = ["aria-label"]

import { Form } from 'vee-validate';
import { useWishlistApi } from '@/shared/product/wishlist/useWishlistApi';
import { computed, ref } from 'vue';
import useWishlist, { ensureOverlayAnimationBeforeClosingTiming } from '@/shared/product/wishlist/useWishlist';
import utilities from '@/shared/utilities.service';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
enum WishlistCreateViwMode {
    Default = 0,
    Create = 1,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WishlistCreate',
  setup(__props) {

const labels = useGlobalLabels(GlobalLabels.wishlist);
const { create, add, get } = useWishlistApi();
const { activeSku, setLists, clearActive } = useWishlist();
const viewMode = ref<WishlistCreateViwMode>(WishlistCreateViwMode.Default);
const setDefaultViewMode = () => viewMode.value = WishlistCreateViwMode.Default;
const setCreateViewMode = () => viewMode.value = WishlistCreateViwMode.Create;
const isDefaultViewMode = computed(() => viewMode.value === WishlistCreateViwMode.Default);

const submit = async({ name }) => {
    const result = await create(name);
    if (result.length === 1) {
        const listId = result[0].id;
        await add(listId, activeSku.value);
        const resultWithAddedItem = await get();
        setLists(resultWithAddedItem);
        await utilities.delay(ensureOverlayAnimationBeforeClosingTiming);
        clearActive();
    } else {
        setLists(result);
        // set delay because of a weird bug where created list doesn't scroll into view if vue updates this component dom at the same time
        setTimeout(setDefaultViewMode, 500);
    }
};


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, {
      name: "o-anim-fade-300",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_unref(isDefaultViewMode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "c-button c-button--outline",
                onClick: setCreateViewMode
              }, _toDisplayString(_unref(labels).addNewListToggleButton), 1)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Form), {
                class: "flex flex-no-wrap ml-3",
                onSubmit: submit
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InputText, {
                    name: "name",
                    rules: "required",
                    "show-errors": false,
                    label: _unref(labels).addNewListInputField,
                    autofocus: true,
                    "input-clear": false,
                    class: "flex-1"
                  }, null, 8, ["label"]),
                  _createElementVNode("button", _hoisted_3, _toDisplayString(_unref(labels).addNewListSubmitButton), 1),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      type: "button",
                      "aria-label": _unref(labels).addNewListCancelButton,
                      class: "text-dusty-grey",
                      onClick: setDefaultViewMode
                    }, [
                      _createVNode(_component_c_icon, {
                        name: "icon-plus",
                        class: "h-15 rotate-45"
                      })
                    ], 8, _hoisted_5)
                  ])
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    })
  ]))
}
}

})